













import Vue, { CreateElement } from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import ConfirmDialog from '@/modules/common/dialog/components/shared/ConfirmDialog.vue'
import { AdminTransactionService } from '@/modules/transaction/services/admin-transaction.service'

@Component({
  components: { BaseButton }
})
export default class AdminTransactionRejectButton extends Vue {
  constructor(
    private readonly transactionService: AdminTransactionService
  ) {
    super()
  }

  @Prop() transactionId!: number
  rejectReason: string = null
  rejectDialog = null
  paidDialogLoading: boolean = false

  rejectDialogShow() {
    this.rejectDialog = this.$q.dialog({
      component: ConfirmDialog,
      title: 'رد تراکنش',
      isAlert: true,
      icon: 'ion close-outline',

      isAsync: true,
      content: (h: CreateElement) => {
        return h('div', {
          staticClass: 'column full-width'
        }, [
          h('base-input', {
            staticClass: 'full-width',
            attrs: {
              value: this.rejectReason,
              type: 'textarea',
              inputStyle: 'height: 80px',
              placeholder: 'دلیل رد کردن را وارد کنید'
            },
            on: {
              input: (value) => this.rejectReason = value
            }
          })
        ])
      }
    }).onOk(() => {
      this.rejectDialog.update({ loading: true })
      this.transactionService.reject(this.transactionId, this.rejectReason).then(() => {
        this.rejectDialog.update({ loading: true })
        this.rejectDialog.hide()
        this.rejectReason = null
      })
    }).onCancel(() => {
      this.rejectReason = null
    })
  }

}
